import SectionTitleEdit from '@/modules/templates/components/TemplateSectionsDrawer/components/Section';
import { getSectionScore, isCoverSection } from '@/utils/managerAuditData';
import { CaretRightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MobileSectionTitleAction from './MobileSectionTitleAction';
import styles from './index.less';

const MobileSectionTitle = ({ section, runAudit, activeKey }) => {
  const { t } = useTranslation('templates');

  const [sectionTitle, score, isCover] = useMemo(() => {
    if (section?.title === 'Introduction' || section?.title === 'Contacts') {
      return [t(section?.title), 0, true];
    }

    return [section?.title, getSectionScore(section), isCoverSection(section)];
  }, [section, t]);

  return (
    <div
      className={
        isCover
          ? styles.sectionHeader
          : styles.sectionPanelHeader
      }
    >
      <div className="flex items-center justify-between" onClick={ (e) => e.preventDefault() }>
        { runAudit && (
          <>{ !activeKey?.length ? <CaretRightOutlined /> : <CaretRightOutlined rotate={ 90 } /> }</>
        ) }
        <div className='w-full'>
          <div className="flex items-center justify-start">
            { runAudit && section?.title !== 'Introduction' && (
              <div className={ classNames(styles.title, 'ml-1') }>
                <SectionTitleEdit section={ section } />
              </div>
            ) }
            { (!runAudit || section?.title === 'Introduction') && (
              <div className={ classNames(styles.title, runAudit ? 'ml-1' : '') }>{ sectionTitle }</div>
            ) }
          </div>
          { runAudit && !isCover && (
            <div className="header-score flex items-center gap-3 ml-2">
              <div className="font-light header-score" style={ { fontSize: '1.2rem' } }>
                { score }
              </div>
            </div>
          ) }
        </div>
        { runAudit && !isCover &&
          <MobileSectionTitleAction
            sectionId={ section?._id }
            isDuplicated={ section?.isDuplicated }
            duplicable={ section?.duplicable }
          />
        }
      </div>
    </div>
  );
};

MobileSectionTitle.propTypes = {
  section: PropTypes.object,
  runAudit: PropTypes.bool,
  activeKey: PropTypes.array,
};

export default memo(MobileSectionTitle);
